// src/plugins/i18n.js


import { createI18n } from 'vue-i18n'

// Define translation messages for each locale
const messages = {
  en: {
    navbar: {
      home: 'Home',
      contact: 'Contact',
      bookNow: 'Book',
      language: 'Language',
      title: 'Lovina'
    },
    HomeVilla: {
      title: 'your elegant hideaway'
    },
    bookingForm: {
      reserveYourStay: 'Reserve Your Stay',
      experienceLuxury: 'Are you looking for romance and relaxation?',
      description1:'Here is your perfect hideaway',
      description2:'A five-star stay awaits you',
      entertainment: 'Entertainment',
      swimming:'Swimming',
      cinema: 'Cinema',
      grill: 'Grill',
      wifi: 'Wi-Fi',
      coffeemaker:'Coffee Machine',
      snacks:'snacks',
      checkin: 'Check-in',
      checkout: 'Check-out',
      fullName: 'Full Name',
      phone: 'Phone',
      email: 'Email',
      confirmBooking: 'Confirm Booking',
      totalPrice: 'Total Price',
      currency: 'O.R',
      promoCode:'Promo Code',
      discount: 'discount',
      addOns: 'Select Add-Ons',
      addOnsDetails:'click here for Add-Ons details',
      selectedAddOns: 'Selected Add-Ons',
      numofdays: 'Total days',
      selectCheckin: 'Select Check-in Date',
      selectCheckout: 'Select Check-out Date',
      ok: 'ok',
      homepage: 'Home Page '
    },
    bookingConfirmation: {
      confirmed: 'Booking Confirmed',
      totalPrice: 'Total Price',
      backToHome: 'Back to Home',
      msg1:'Bank Muscat',
      msg2:'Account Number: 0335019316300038',
      msg3:'Name: Younis Al-Rashdi',
      msg4:'Alternatively, you can use the phone number: 94013018' ,
      msg5:'Please send the receipt via WhatsApp to confirm the reservation at the number: 94643800.',
      msg6:'The amount is non-refundable, but you can change the reservation up to 3 days in advance at most.',
    },
    chaletDetail: {
      contactus: 'Contact us',
    },
    // add other keys as needed
  },
  ar: {
    navbar: {
      home: 'الرئيسية',
      contact: 'تواصل معنا',
      bookNow: 'احجز الآن',
      language: 'اللغة',
      title:"لوفينا"
    },
    HomeVilla: {
      title: 'هنا مخبأك المثالي'
    },
    bookingForm: {
      reserveYourStay: 'احجز إقامتك',
      experienceLuxury: 'هل تبحث عن مخبأك المثالي؟',
      description1:' هنا مخبأك المثالي',
      description2:'إقامة خمس نجوم تنتظرك',
      entertainment: 'ترفيه',
      swimming:'حوض سباحة',
      cinema: 'سينما',
      grill: 'شواية',
      wifi: 'واي فاي',
      coffeemaker:'مكينة قهوة',
      snacks:'حسوس',
      checkin: 'تاريخ الوصول',
      checkout: 'تاريخ المغادرة',
      fullName: 'الاسم الكامل',
      phone: 'رقم الهاتف',
      email: 'البريد الإلكتروني',
      confirmBooking: 'تأكيد الحجز',
      totalPrice: 'السعر الإجمالي',
      currency: 'ر.ع',
      promoCode:'رمز الخصم',
      discount:'الخصم',
      addOns: 'اختر الإضافات',
      addOnsDetails:'اضغظ هنا لمعرفة تفاصيل الإضافات',
      selectedAddOns: 'الإضافات المختارة',
      numofdays: 'عدد الإيام',
      selectCheckin: 'اختر تاريخ الوصول',
      selectCheckout: 'اختر تاريخ المغادرة',
      ok: 'موافق',
      homepage: 'الصفحة الرئيسية'
    },
    bookingConfirmation: {
      confirmed: 'تم تأكيد الحجز',
      totalPrice: 'السعر الإجمالي',
      backToHome: ' إلى الصفحة الرئيسية',
      msg1:'بنك مسقط',
      msg2:'رقم الحساب: 0335019316300038',
      msg3:'الاسم: يونس الراشدي',
      msg4:'يمكنك أيضًا استخدام رقم الهاتف: 94013018',
      msg5:'يرجى إرسال الإيصال عبر الواتساب لتأكيد الحجز على الرقم: 94643800',
      msg6:' المبلغ غير قابل للاسترداد, ولكن يمكنك تغيير الحجز قبل 3 أيام على الأكثر.',
    },
    chaletDetail: {
      contactus: ' تواصل معنا',
    },
    // add other keys as needed
  }
}

// Create and export the i18n instance
export default createI18n({
  legacy: false,        // Disable legacy mode to use Composition API
  locale: 'en',         // Default locale
  fallbackLocale: 'en',
  messages
})
